<template>
	<Dialog
		v-model="showDialog"
		:title="$t('login.msg_sms')"
		:hide-cancel="true"
		:confirm-text="$t('login.verification')"
		@confirm="confirm"
	>
		<el-form :model="form" ref="ruleFormRef">
			<el-form-item>
				{{ $t('login.user') }} {{ maskPhoneNumber(String(mobile)) }} {{ $t('login.code') }}
			</el-form-item>
			<el-form-item
				prop="code"
				:rules="[
					{ required: true, message: $t('login.pl_code'), whitespace: true, trigger: 'change' },
				]"
			>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-input v-model="form.code" :placeholder="$t('login.pl_code')" autocomplete="off" />
					</el-col>
					<el-col :span="12">
						<Verification
							@change="getCode"
							:formData="{
								sms: 'loginCode',
								are: '86',
								mobile: mobile,
							}"
						/>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
	</Dialog>
</template>

<script lang="ts" setup>
import { ref, watchEffect } from 'vue'
import Dialog from '/@/components/dialog/Dialog.vue'
import Verification from './Verification.vue'
import { maskPhoneNumber } from '@/utils'
const props = defineProps<{
	modelValue: boolean
	mobile: string | number
}>()
const emits = defineEmits(['cancel', 'confirm', 'close', 'update:modelValue'])

const form = ref({
	code: '',
	mobile: props.mobile,
})
const showDialog = ref(props.modelValue)

watchEffect(() => {
	showDialog.value = props.modelValue
})

watchEffect(() => {
	emits('update:modelValue', showDialog.value)
})

const areaCode = ref('')
const getCode = (code: string) => {
	areaCode.value = code
}
const ruleFormRef = ref()
const confirm = () => {
	ruleFormRef.value.validate(async (valid) => {
		if (!valid) return
		emits('update:modelValue', false)
		emits('confirm', { code: form.value.code, area_code: areaCode.value })
	})
}
</script>

<style scoped lang="scss"></style>
